<template>
    <div class="white-bg">
        <top-carousel></top-carousel>
        <div class="body-nav">
            <ul class="ul-nav page-width container" id="tabs">
                <li id="1">资质荣誉</li>
                <li id="2">质量管理体系认证</li>
                <li id="3">软著与专利</li>
            </ul>
        </div>
        <honor-img :list="list"></honor-img>
    </div>
</template>

<script>
import honorImg from './honorImg'
import $ from 'jquery'
export default {
    components: {
        honorImg,
    },
    data() {
        return {
            certificateList: [
                {
                    id: 1,
                    list: [
                        {
                            url: require('../../../../assets/img/honor/i1.png'),
                            title: '高新技术企业证书',
                        },
                        {
                            url: require('../../../../assets/img/honor/i2.png'),
                            title: '技术贸易资格证',
                        },
                        {
                            url: require('../../../../assets/img/honor/i3.png'),
                            title: '装修、消防、照明证书',
                        },
                        {
                            url: require('../../../../assets/img/honor/i4.png'),
                            title: '机电、智能化证书',
                        },
                        {
                            url: require('../../../../assets/img/honor/i5.png'),
                            title: '智能化设计证书',
                        },
                        {
                            url: require('../../../../assets/img/honor/i6.png'),
                            title: '安全生产许可证',
                        },
                    ],
                },
                {
                    id: 2,
                    list: [
                        {
                            url: require('../../../../assets/img/quality/i1.png'),
                            title: '质量管理体系认证证书',
                        },
                        {
                            url: require('../../../../assets/img/quality/i2.png'),
                            title: '质量管理体系认证证书',
                        },
                        {
                            url: require('../../../../assets/img/quality/i3.png'),
                            title: '质量证书',
                        },
                        {
                            url: require('../../../../assets/img/quality/i4.png'),
                            title: '环境管理体系证书',
                        },
                        {
                            url: require('../../../../assets/img/quality/i5.png'),
                            title: '环境管理体系证书',
                        },
                        {
                            url: require('../../../../assets/img/quality/i6.png'),
                            title: '职业健康体系认证证书',
                        },
                        {
                            url: require('../../../../assets/img/quality/i7.png'),
                            title: '职业健康体系认证证书',
                        },
                    ],
                },
                {
                    id: 3,
                    list: [
                        {
                            url: require('../../../../assets/img/softness/i1.jpg'),
                            title: '空调自控系统等7个软件著作权',
                        },
                        {
                            url: require('../../../../assets/img/softness/i2.jpg'),
                            title: '环境监测与设备控制等5个软件著作权',
                        },
                        {
                            url: require('../../../../assets/img/softness/i3.jpg'),
                            title: '能源管理等4个软件著作权',
                        },
                        {
                            url: require('../../../../assets/img/softness/i4.jpg'),
                            title: '智能可视化数字工厂管理品台等4个软件等著作权',
                        },
                    ],
                },
            ],
            list: [],
            id: this.$route.params.id,
        }
    },
    methods: {
        toggleTab() {
            let that = this
            $('#tabs').on('click', 'li', function () {
                that.$router.push('/news/' + this.id)
            })
        },
        setCurrentTab() {
            let that = this
            $('#' + this.id)
                .addClass('active')
                .siblings()
                .removeClass('active')
            if (that.id == 4) {
                let arr = []
                that.certificateList.map((item) => {
                    arr = arr.concat(item.list)
                })
                that.list = arr
            } else {
                that.list = that.certificateList.find((item) => {
                    return item.id == that.id
                }).list
            }
        },
    },
    mounted() {
        this.toggleTab()
        this.setCurrentTab()
    },
}
</script>
